export const validateMode = (mode, modesAvailable) =>
{
    let valid = false;

    Object.entries(modesAvailable).forEach(([key, value]) => {

        if (value === mode)
        {
            valid = true;
        }
    });

    if (!valid)
    {
        throw new Error("Invalid Mode");
    }
}
